import type { Contributor } from '../types';

export function reindexContributors(contributors: Contributor[]): Contributor[] {
  return contributors.map((contributor, index) => ({
    ...contributor,
    displayOrder: index + 1
  }));
}

export function normalizeHydratedContributors(contributors: Contributor[]): Contributor[] {
  return reindexContributors(
    contributors
      .map((contributor, index) => ({
        contributor,
        index
      }))
      .sort((left, right) => {
        const leftOrder =
          typeof left.contributor.displayOrder === 'number'
            ? left.contributor.displayOrder
            : left.index + 1;
        const rightOrder =
          typeof right.contributor.displayOrder === 'number'
            ? right.contributor.displayOrder
            : right.index + 1;

        if (leftOrder !== rightOrder) {
          return leftOrder - rightOrder;
        }

        return left.index - right.index;
      })
      .map(({ contributor }) => contributor)
  );
}
